import React, { useEffect, useState, useRef, memo } from "react";
import { Button, message, Select, Spin } from "antd";
import moment from "moment";
import { Form, RangePicker } from "antd";
import { DatePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
// import "antd/dist/antd.css";
import { API_URL } from "../../environment";
import {
  ALLLEAVES_DATA,
  LEAVE_APPLY,
  USERMAILING_LIST,
  USER_DETAIL,
} from "../../redux/Store/constants";
import { useDispatch } from "react-redux";
import { TimePicker } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeader from "../../components/global/SectionHeader";
// import "antd/dist/reset.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../leaves/Leaveform.css";
import { notification } from "antd";
import { Tooltip } from "antd";
import Layout from "../../components/global/layout";
import { BsArrowLeftSquare } from "react-icons/bs";
import ApiClient from "../../api/apiClient";
import dayjs from 'dayjs';
import datepipeModel from "../../models/datepipemodel";

//date component
const DateRangePicker = memo(({ dateFormat, onChange, defaultValue = [] }) => {
  const { RangePicker } = DatePicker;
  const [loading, setLoading] = useState(false)

 
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 100)
  }, [defaultValue?.length])
  return <>
    {loading ? <>
      <div className="shine">Loading...</div>
    </> : <>
      <RangePicker
        format={dateFormat}
        onChange={onChange}
        defaultValue={defaultValue.length ? [
          dayjs(defaultValue[0], dateFormat),
          dayjs(defaultValue[1], dateFormat)
        ] : null}
      />
    </>}

  </>
})
// TimeRangePicker component to handle the start and end time range
// const TimeRangePicker = memo(({ timeFormat, onChange, defaultValue = [] }) => {
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//     }, 100);
//   }, [defaultValue?.length]);

//   return (
//     <>
//       {loading ? (
//         <div className="shine">Loading...</div>
//       ) : (
//         <TimePicker.RangePicker
//           format={timeFormat}
//           onChange={onChange}
//           defaultValue={
//             defaultValue.length
//               ? [
//                 dayjs(defaultValue[0], timeFormat),
//                 dayjs(defaultValue[1], timeFormat),
//               ]
//               : null
//           }
//         />
//       )}
//     </>
//   );
// });
const Leavelist = () => {
  let  istl =localStorage.getItem("tl");
  const dispatch = useDispatch();
  const { Option } = Select;
  const [Text, setText] = useState('');
  const Email = localStorage.getItem("Email");
  let history = useNavigate();
  const userid = localStorage.getItem("USERID");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const token = localStorage.getItem("token");
  const [mailinglist, setMailinglist] = useState([]);
  const [typeMail, setTypeMail] = useState([]);
  const [subject, setSubject] = useState("");
  const [startTime, setStartTime] = useState(dayjs());
  console.log(startTime, "startTime")
  const [endTime, setEndTime] = useState(dayjs());
  console.log(endTime, "endTime")
  const [loading, setloading] = useState(false);
  const dateFormat = 'YYYY-MM-DD';
  const [dates, setDates] = useState([]);
  const ID = useParams()

  useEffect(() => {
    console.log(ID, 'ID');
    mailingList();
    if (ID.id)
      userDetails();
  }, []);

  const userDetails = () => {
    ApiClient.get(`getsingleleave?id=${ID.id}`)
      .then((res) => {
        if (res && res?.data) {
          setTypeMail(res?.data?.toEmail);
          setSubject(res?.data?.subject);

          if (res?.data?.leaveStartDate && res?.data?.leaveEndDate) {
            setDates(res?.data?.dates);
            console.log(res?.data?.dates, 'res?.data?.dates')
          }

          setText(res?.data?.description);
          setStartTime(res?.data?.leaveStarttime);
          setEndTime(res?.data?.leaveEndtime);
        } else if (res.success === false) {
          notification.error({
            message: "Enter valid Email or Password"
          });
        }
      });
  };
  const mailingList = () => {
    let data ={
      isDeleted:false,
      isTL:istl
    }
    ApiClient.get('user/mailingList',data)
      .then((res) => {
        setMailinglist(res.data);
        if (res && res.data && res.data.access_token) {
          dispatch({
            type: USERMAILING_LIST,
            payload: res,
          });
          //history("/dashboard")
        } else {
          // alert('Enter valid Email or Password');
        }
      });
  };

  const setTime = (e) => {
    setStartTime(e[0]._d);
    setEndTime(e[1]._d);
  };

  const uniqueValues = [];
  mailinglist?.map((entry) => {
    uniqueValues.push(entry);
  });

  function handleChange(value) {
    console.log(value, '===');
    setTypeMail(value);
  }

  function handleChangeType(value) {
    console.log(value, "++++++");
    setSubject(value);
  }

  var event = new Date(startDate._d);
  let sdate = JSON.stringify(event);
  sdate = sdate.slice(1, 11);

  var event = new Date(endDate._d);
  let edate = JSON.stringify(event);
  edate = edate.slice(1, 11);

  const onFinish = (values) => {

    const newemail = values.toEmail;
    const payload = {
      subject: values.subject,
      description: values.description,
      leaveStartDate: dates[0],
      leaveEndDate: dates[1],
      dates: dates,
      toEmail: typeMail,
      leaveStarttime: startTime,
      leaveEndtime: endTime,
    };
    setloading(true)
    if (!ID.id) {
      ApiClient.post(`leaves/add`, payload)
        .then((res) => {
          history("/leavelist");
          AllLeves();
          if (res) {
            if (res?.success == true) {
              setloading(false)
              notification.success({
                message: "Leave apply successfully",
              });
              dispatch({
                type: LEAVE_APPLY,
                payload: res,
              });
            }
          }
        });
    } else {
      const payload = {
        subject: values.subject,
        description: values.description,
        leaveStartDate: dates[0],
        leaveEndDate: dates[1],
        dates: dates,
        toEmail: typeMail,
        leaveStarttime: startTime,
        leaveEndtime: endTime,
        id: ID.id,
      };
      setloading(true)
      ApiClient.put(`leaves/edit`, payload)
        .then((res) => {
          history("/leavelist");
          AllLeves();
          if (res) {
            if (res?.success == true) {
              setloading(false)
              notification.success({
                message: "Leave has been Updated",
              });
              dispatch({
                type: LEAVE_APPLY,
                payload: res,
              });
            }
          }
        });
    }
  };

  const onFinishFailed = (errorInfo) => { };

  const AllLeves = () => {
    setloading(true);
    ApiClient.get(`allleaves?search=${Email}&count=1000&isDeleted=false`)
      .then((res) => {
        if (res && res.data && res.data.access_token) {
          setloading(false);
          dispatch({
            type: ALLLEAVES_DATA,
            payload: res,
          });
        } else {
        }
      });
  };
  const iconbtn = () => {
    history("/leavelist");
  };

  const onChange = (dates) => {
    const formattedDates = dates ? [
      ...dates.map(itm => datepipeModel.datetostring(itm.$d.toUTCString()))
    ] : [];
    setDates(formattedDates);
    console.log(formattedDates, "Formatted Dates");
  };

  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="headings">
            <div className="d-flex align-items-center gap-3">
              <Tooltip title="Back Button">
                <p onClick={iconbtn} className="pointer text-white  fs-3">
                  <BsArrowLeftSquare />
                </p>
              </Tooltip>
              <SectionHeader title="Edit The Leave Form" />
            </div>
          </div>

          <div className="profile_section_name">
            <div className="section">
              <div>
                <Spin spinning={loading}>
                  <div className="container_div">
                    <Form
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      autoComplete="off"
                    >
                      <div class="row">
                        <div class="form-group col-md-6 pointer">
                          <label for="inputEmail4">
                            To<span class="text-danger">*</span>
                          </label>
                          <Form.Item
                            name="toEmail"
                            rules={[
                              { required: true, message: "Please Select Email!" },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="Select one Email"
                              size="large"
                              onChange={handleChange}
                              key={typeMail}
                              value={typeMail}

                              defaultValue={typeMail}
                              optionLabelProp="label"
                            >
                              {mailinglist &&
                                mailinglist.map((item) => (
                                  <Option key={item.email}>{item.email}</Option>
                                ))}
                            </Select>
                          </Form.Item>
                          <svg
                            className="alignIcon"
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="down"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="false"
                          >
                            <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
                          </svg>
                        </div>
                        <div class="form-group col-md-6">
                          <label for="inputAddress">
                            Type<span class="text-danger">*</span>
                          </label>
                          <Form.Item
                            name="subject"
                            rules={[
                              { required: true, message: "Please Select Type!" },
                            ]}
                          >
                            <Select
                              placeholder="Select the Type"
                              size="large"
                              key={subject}
                              value={subject}
                              onChange={handleChangeType}
                              defaultValue={subject}
                              options={[
                                {
                                  value: 'Emergency Leave',
                                  label: 'Emergency Leave',
                                },
                                {
                                  value: 'Medical Leave',
                                  label: 'Medical Leave',
                                },
                                {
                                  value: "full day Leave",
                                  label: 'Full day Leave',
                                },
                                {
                                  value: 'half day Leave',
                                  label: 'Half day Leave',
                                },
                                {
                                  value: 'short Leave',
                                  label: 'Short Leave',
                                },
                              ]}
                            >

                            </Select>
                          </Form.Item>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-6">
                            <label for="inputAddress">
                              Start Date - End Date
                              <span class="text-danger">*</span>
                            </label>
                            <Form.Item rules={[
                              {
                                required: true,
                                message: "Please Select Start & End Date!",
                              },
                            ]} name="dateRange">

                              <DateRangePicker
                                format={dateFormat}
                                onChange={onChange}
                                defaultValue={dates}
                              // disabledDate={(current) =>
                              //   current && current < moment().startOf("day")
                              // }
                              />
                            </Form.Item>
                          </div>
                          {subject === "half day Leave" ||
                            subject === "short Leave" ? (
                            <div class="form-group col-md-6">
                              <label for="inputAddress">
                                Start Time - End Time
                                <span class="text-danger">*</span>
                              </label>

                              <Form.Item
                                name="leavestartandendtime"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Please Select Start Time & End Time!",
                                  },
                                ]}
                              >
                                <TimePicker.RangePicker
                                  size="large"
                                  value={[dayjs(startTime, "HH:mm:ss"), dayjs(endTime, "HH:mm:ss")]}
                                  onChange={(time) => {
                                    console.log(time[0].format("HH:mm:ss"))
                                    setStartTime(time[0].format("HH:mm:ss"));
                                    setEndTime(time[1].format("HH:mm:ss"));
                                  }}
                                />
                              </Form.Item>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div class="form-group col-md-12">
                          <label for="inputAddress">
                            Reason<span class="text-danger">*</span>
                          </label>
                          <Form.Item
                            name="description"
                            valuePropName="data"
                            getValueFromEvent={(event, editor) => {
                              const data = editor.getData();
                              return data;
                            }}
                            rules={[
                              {
                                required: true,
                                message: "  Enter the Reason",
                              },
                            ]}
                          >
                            {/* onChange={(event, editor) => {
                                const data = editor.getData();
                                setText(data);
                              }} */}
                            <CKEditor
                              data={Text}
                              key={Text}
                              config={{
                                initialData: Text,
                              }}
                              editor={ClassicEditor}

                            />
                          </Form.Item>
                        </div>
                      </div>

                      <div className="btn_submit">
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                          >
                            {ID.id ? "Update" : "Submit"}
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Leavelist;
